import { ReviewInterface } from '@hydra/types/review';

export const getFavicon = (review: ReviewInterface | null): string | null => {
  if (review && review.criteria && review.criteria.favicon && review.criteria.favicon.data) {
    const data = review.criteria.favicon.data;

    if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'string') {
      return data[0];
    }

    if (data && Array.isArray(data.favicons) && data.favicons.length > 0 && typeof data.favicons[0].href === 'string') {
      return data.favicons[0].href;
    }
  }

  return null;
};
